/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSnapshotFilter model module.
 * @module model/AqaSnapshotFilter
 * @version v0
 */
export default class AqaSnapshotFilter {
  /**
   * Constructs a new <code>AqaSnapshotFilter</code>.
   * @alias module:model/AqaSnapshotFilter
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSnapshotFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSnapshotFilter} obj Optional instance to populate.
   * @return {module:model/AqaSnapshotFilter} The populated <code>AqaSnapshotFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSnapshotFilter();
      if (data.hasOwnProperty('orientation'))
        obj.orientation = ApiClient.convertToType(data['orientation'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('valueFrom'))
        obj.valueFrom = ApiClient.convertToType(data['valueFrom'], 'String');
      if (data.hasOwnProperty('valueTo'))
        obj.valueTo = ApiClient.convertToType(data['valueTo'], 'String');
      if (data.hasOwnProperty('subType'))
        obj.subType = ApiClient.convertToType(data['subType'], 'Number');
      if (data.hasOwnProperty('onlyReds'))
        obj.onlyReds = ApiClient.convertToType(data['onlyReds'], 'Boolean');
      if (data.hasOwnProperty('onlyAmbers'))
        obj.onlyAmbers = ApiClient.convertToType(data['onlyAmbers'], 'Boolean');
      if (data.hasOwnProperty('onlyGreens'))
        obj.onlyGreens = ApiClient.convertToType(data['onlyGreens'], 'Boolean');
      if (data.hasOwnProperty('reviewType'))
        obj.reviewType = ApiClient.convertToType(data['reviewType'], 'Number');
      if (data.hasOwnProperty('finerGrain'))
        obj.finerGrain = ApiClient.convertToType(data['finerGrain'], 'Number');
      if (data.hasOwnProperty('rowBased'))
        obj.rowBased = ApiClient.convertToType(data['rowBased'], 'Boolean');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>orientation</code> property.
 * @enum {String}
 * @readonly
 */
AqaSnapshotFilter.OrientationEnum = {
  /**
   * value: "column"
   * @const
   */
  column: "column",

  /**
   * value: "row"
   * @const
   */
  row: "row"
};
/**
 * @member {module:model/AqaSnapshotFilter.OrientationEnum} orientation
 */
AqaSnapshotFilter.prototype.orientation = undefined;

/**
 * @member {Number} position
 */
AqaSnapshotFilter.prototype.position = undefined;

/**
 * @member {String} valueFrom
 */
AqaSnapshotFilter.prototype.valueFrom = undefined;

/**
 * @member {String} valueTo
 */
AqaSnapshotFilter.prototype.valueTo = undefined;

/**
 * @member {Number} subType
 */
AqaSnapshotFilter.prototype.subType = undefined;

/**
 * @member {Boolean} onlyReds
 */
AqaSnapshotFilter.prototype.onlyReds = undefined;

/**
 * @member {Boolean} onlyAmbers
 */
AqaSnapshotFilter.prototype.onlyAmbers = undefined;

/**
 * @member {Boolean} onlyGreens
 */
AqaSnapshotFilter.prototype.onlyGreens = undefined;

/**
 * @member {Number} reviewType
 */
AqaSnapshotFilter.prototype.reviewType = undefined;

/**
 * @member {Number} finerGrain
 */
AqaSnapshotFilter.prototype.finerGrain = undefined;

/**
 * @member {Boolean} rowBased
 */
AqaSnapshotFilter.prototype.rowBased = undefined;

/**
 * @member {String} type
 */
AqaSnapshotFilter.prototype.type = undefined;

